// reducers/profileReducer.js
import * as types from '../types/profileTypes';
const initialState = {
  data: null,
  loading: false,
  error: null,
};

const encodeJson = (data) => {
  return data ? btoa(encodeURIComponent(JSON.stringify(data))) : '';
};

const profileReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_PROFILE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case types.FETCH_PROFILE_SUCCESS:
      return {
        ...state,
        loading: false,
        data: encodeJson(action.payload),
        error: null,
      };
    case types.FETCH_PROFILE_FAILURE:
      return {
        ...state,
        loading: false,
        data: null,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default profileReducer;
